import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function Ressult() {
  return (
    <section className="result_pick p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <h2 style={{ color: "#000" }}>
              The <span style={{ color: "#F44336" }}>Results</span>
            </h2>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-1 offset-lg-1"
          >
            <p>
              We paired the best of gaming entertainment, with effective app
              monetization strategies to give the perfect form to the Picture
              Pick app. The result was the creation of an efficient, easy to use
              and entertaining game app, that’s filled with bundles of rewarding
              prizes for users.
            </p>
            <div className="result_main_num">
              <div className="result_num_box">
                <h2>3000+</h2>
                <p>DOWNLOADS</p>
              </div>
              <div className="result_num_box">
                <h2>4.6+</h2>
                <p>RATING</p>
              </div>
              <div className="result_num_box">
                <h2>60+</h2>
                <p>REVIEWS</p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Ressult;
